import { DateTime } from 'luxon';

export default function isSameDay(a, b) {
  if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;

 
  return a.day === b.day && a.month === b.month && a.year === b.year;
}
